module.exports = __webpack_public_path__ + "img/plus.9bd2afaf.svg";